import { errorMessage } from 'constants/CommonConstants';
import { formRequiredRules } from 'helper';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputRadio } from 'sharedComponents/inputGroup/InputRadio';
import { CREDIT_SCORE_OPTION } from '../LeadGenConstant';
import { Lead } from '../LeadGenInterface';
import { postLeadCreation } from 'store/LeadCreationState';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { useDispatch, useSelector } from 'react-redux';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';

const CreditScoreSelection: React.ForwardRefRenderFunction<unknown, StepperFromProps> = (
  { onNext, onBack, isSubmit, mappedData },
  ref
) => {
  // Hooks
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);

  // Redux
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { authenticateClientData } = useSelector((state: RootState) => state.auth) || {};
  const widgetData = authenticateClientData?.data?.widgetData || {};

  // React Hook Form
  const { control, trigger, getValues } = useFormContext();

  // React Hook Form Trigger
  const nextStep = () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { estimatedCreditRating } = getValues();

    const creditScoreData: Lead = {
      leadSourceId: widgetData?.leadSourceId,
      isSubmit,
      leadDetails: {
        'Estimated Credit Rating': estimatedCreditRating,
        ...mappedData,
      },
    };

    dispatch(postLeadCreation({ data: creditScoreData, leadTypeID: widgetData?.leadTypeId })).then((res) => {
      if (
        res?.payload?.success &&
        (res?.payload?.data?.draftLeadId || res?.payload?.data?._id || res?.payload?.data?.Lead?.leadId)
      ) {
        onNext?.();
      }
    });
  };

  const backStep = () => {
    onBack?.();
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <>
      <h3 className='dy-stepper-form__body__title text-center'>{t('leadGen.creditScoreTxt')}</h3>
      <InputRadio
        rules={formRequiredRules(errorMessage(t).radioError)}
        name={'estimatedCreditRating'}
        control={control}
        options={CREDIT_SCORE_OPTION(t)}
        directionRow={false}
        triggerValidationForField={(name: string) => {
          trigger(name);
          onNext?.();
        }}
        itemPerRow={{
          xs: 12,
          sm: 6,
          lg: 6,
        }}
        radioVariant='outline'
      />
    </>
  );
};

const CreditScoreSelectionStep = React.forwardRef(CreditScoreSelection);

export default CreditScoreSelectionStep;
